import {
    Table,
    TableBody,
    TableCaption,
    TableCell,
    TableFooter,
    TableHead,
    TableHeader,
    TableRow,
} from "./../../ui/table"
import styled from "styled-components"

const Styletable = styled.div`

.p-4 {
    padding: 1em !important;
}
`

const items = [
    {
        key: 1,
        type: '最新消息',
        date: '2024/1/1',
        title: '最新書刊公告',
    },
    {
        key: 2,
        type: '最新消息',
        date: '2024/1/1',
        title: '最新書刊公告',
    },
    {
        key: 3,
        type: '最新消息',
        date: '2024/1/1',
        title: '最新書刊公告',
    },
    {
        key: 4,
        type: '最新消息',
        date: '2024/1/1',
        title: '最新書刊公告',
    },
]

const TableDemo = ({ item = items }) => {
    return (
        <Styletable>
            <Table>
                {/* <TableHeader>
                <TableRow>
                    <TableHead className="w-[100px]">Invoice</TableHead>
                    <TableHead>Status</TableHead>
                    <TableHead>Method</TableHead>
                    <TableHead className="text-right">Amount</TableHead>
                </TableRow>
            </TableHeader> */}
                <TableBody>
                    {item.map((e) => (
                        <TableRow key={e.key} style={{ border: '1px solid', borderLeftWidth: '0px', borderRightWidth: '0px' }} >
                            <TableCell style={{ padding: '0em', width: '8em', textAlign: 'center', backgroundColor: '#DDF1F9', fontWeight: 700 }}>{e.type}</TableCell>
                            {e.date ? <TableCell style={{ padding: '0em', width: '10em', textAlign: 'center', }}>{e.date}</TableCell> : <></>}
                            <TableCell style={{ padding: '0em', }}>{e.title}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
                {/* <TableFooter>
                <TableRow>
                    <TableCell colSpan={3}>Total</TableCell>
                    <TableCell className="text-right">$2,500.00</TableCell>
                </TableRow>
            </TableFooter> */}
            </Table>
            <div style={{ width: '100%', textAlign: 'end' }} ><a href="/">more</a></div>
        </Styletable>
    )
}

export default TableDemo